import EventCategoryEdit from "@/components/Events/EventCategoryEdit/EventCategoryEdit.vue";
import EventCategoryGroupEdit from "@/components/Events/EventCategoryGroupEdit/EventCategoryGroupEdit.vue";
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

export default {
  name: "EventAdminCategories",
  data: () => ({
    editedCategory: {},
    showCategoryEdit: false,
    editedCategoryGroup: {},
    showCategoryGroupEdit: false,
    subScribedCategoryGroups: []
  }),
  async mounted() {
    try {
      await this.$store.dispatch("getCategoryGroupsForEvents", {
        ignorePrincipal: !!this.isAdmin
      });
    } catch (err) {
      await this.$store.dispatch("createError", err);
    }
  },
  methods: {
    editCategory(category) {
      this.showCategoryEdit = true;
      this.editedCategory = category;
    },
    async saveCategory() {
      try {
        const headers = getTokenHeader();
        let response;
        if (this.editedCategory._id)
          response = await axios.put(
            `${env.events_api_client_url}category`,
            this.editedCategory,
            { headers }
          );
        else
          response = await axios.post(
            `${env.events_api_client_url}category`,
            this.editedCategory,
            { headers }
          );
        if (response.status === 200 || response.status === 201) {
          this.editedCategory = {};
          this.showCategoryEdit = false;
          await this.$store.dispatch("getCategoryGroupsForEvents", {
            ignorePrincipal: true
          });
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async deleteCategory(id) {
      try {
        const isConfirmed = await this.$confirm(
          "Sind Sie sicher, dass diese Kategorie löschen möchten?",
          confirmWarningConfig
        );
        if (isConfirmed) {
          const headers = getTokenHeader();
          const response = await axios.delete(
            `${env.events_api_client_url}category/${id}`,
            { headers }
          );
          if (response.status === 200) {
            await this.$store.dispatch("getCategoryGroupsForEvents", {
              ignorePrincipal: true
            });
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
          }
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async deleteCategoryGroup(id) {
      try {
        const isConfirmed = await this.$confirm(
          "Sind Sie sicher, dass diese Kategoriegruppe löschen möchten?",
          confirmWarningConfig
        );
        if (isConfirmed) {
          const headers = getTokenHeader();
          const response = await axios.delete(
            `${env.events_api_client_url}category_group/${id}`,
            { headers }
          );
          if (response.status === 200) {
            await this.$store.dispatch("getCategoryGroupsForEvents", {
              ignorePrincipal: true
            });
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
          }
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async saveCategoryGroup() {
      try {
        const headers = getTokenHeader();
        let response;
        if (this.editedCategoryGroup._id)
          response = await axios.put(
            `${env.events_api_client_url}category_group`,
            this.editedCategoryGroup,
            { headers, principal_id: this.selectedPrincipal.id }
          );
        else
          response = await axios.post(
            `${env.events_api_client_url}category_group`,
            this.editedCategoryGroup,
            { headers, principal_id: this.selectedPrincipal.id }
          );
        if (response.status === 200 || response.status === 201) {
          this.editedCategoryGroup = {};
          this.showCategoryGroupEdit = false;
          await this.$store.dispatch("getCategoryGroupsForEvents", {
            ignorePrincipal: 1
          });
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    editCategoryGroup(categoryGroup) {
      this.showCategoryGroupEdit = true;
      this.editedCategoryGroup = categoryGroup;
    },
    async updateSubscription(categoryGroups) {
      if (categoryGroups.length === this.subScribedCategoryGroups.length)
        return;
      if (categoryGroups.length > this.subScribedCategoryGroups.length) {
        await this.addSubscription(categoryGroups);
      }
      if (categoryGroups.length < this.subScribedCategoryGroups.length) {
        await this.deleteSubscription(categoryGroups);
      }
      await this.$store.dispatch("getCategoryGroupsForEvents", {
        ignorePrincipal: true
      });
    },
    async addSubscription(categoryGroups) {
      const newSubscription = categoryGroups[categoryGroups.length - 1];
      const foundCategory = this.categoryGroups.find(
        catGroup => catGroup._id === newSubscription
      );
      if (foundCategory)
        foundCategory.principals.push(this.selectedPrincipal.id);
      this.editedCategoryGroup = foundCategory;
      await this.saveCategoryGroup();
    },
    async deleteSubscription(categoryGroups) {
      const deletedCategoryGroup = this.subScribedCategoryGroups.find(
        subCatGroup => !categoryGroups.includes(subCatGroup)
      );
      const foundCategory = this.categoryGroups.find(
        catGroup => catGroup._id === deletedCategoryGroup
      );
      if (foundCategory)
        foundCategory.principals.remove(this.selectedPrincipal.id);
      this.editedCategoryGroup = foundCategory;
      await this.saveCategoryGroup();
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isEventAdmin() {
      return this.currentUser?.scopes?.includes("role:events_admin");
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    globalCategoryGroups() {
      return this.categoryGroups.filter(catGroup => !catGroup.owner_id);
    },
    ownCategoryGroups() {
      return this.categoryGroups.filter(catGroup => catGroup.owner_id);
    },
    cSelectedCategoryGroups: {
      get() {
        const subscribedCatGroups = this.$store.state.categoryGroupsForEvents.filter(
          catGroup => catGroup.principals.includes(this.selectedPrincipal.id)
        );
        this.subScribedCategoryGroups = subscribedCatGroups.map(
          subscribedCatGroup => subscribedCatGroup._id
        );
        return subscribedCatGroups;
      },
      set(value) {
        this.updateSubscription(value);
        this.subScribedCategoryGroups = value;
      }
    },
    categoryGroups() {
      return this.$store.state.categoryGroupsForEvents;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  },
  components: { EventCategoryEdit, EventCategoryGroupEdit }
};
